module.exports = __webpack_public_path__ + "static/media/country_flag_switzerland.69547e25.svg";